import { Controller } from "@hotwired/stimulus";
import { skeletonMessage } from "../helpers/dom_helpers";

export default class MessagesHistoryController extends Controller {
  connect() {
    this.popStateHandler = this.handlePopState.bind(this);
    globalThis.addEventListener("popstate", this.popStateHandler);
  }

  disconnect() {
    globalThis.removeEventListener("popstate", this.popStateHandler);
  }

  handlePopState() {
    const path = globalThis.location.pathname;
    const roomId = new RegExp(/^\/messages\/(\d+)$/).exec(path)?.[1];

    if (roomId) {
      this.handleRoom(roomId);
    } else if (path === "/messages") {
      Turbo.visit("/messages");
    }
  }

  handleRoom(roomId) {
    this.setActiveRoom(roomId);
    this.toggleRoom(true);
    this.loadConversation(roomId);
  }

  setActiveRoom(roomId) {
    $(".room-user").removeClass("active disabled-link");
    const roomElement = document.querySelector(`.room-user[data-room-id='${roomId}']`);
    roomElement?.classList.add("active", "disabled-link");
  }

  toggleRoom(isRoomVisible) {
    if (globalThis.innerWidth < 512) {
      $("#user-list").toggleClass("d-none", isRoomVisible);
      $("#chat-area").toggleClass("d-none", !isRoomVisible);
      $("#header-back-btn").toggleClass("d-none", !isRoomVisible);
    }
  }

  async loadConversation(roomId) {
    const chatArea = document.getElementById("chat-area");
    if (!chatArea) return;

    chatArea.innerHTML = skeletonMessage();
    const turboRequest = (await import("../helpers/api")).turboRequest;

    await turboRequest(`/messages/${roomId}`, {
      method: "GET",
      turboStream: true
    });
  }

}
